import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "./api";
import toast from "react-hot-toast";

export const useAdminChats = () => {
    return useQuery({
        queryKey: ["adminChats"],
        queryFn: async () => {
            const res = await api.get("/company/chats");
            return res.data.data;
        },
        refetchInterval: 3000, // Poll every 3 seconds
    });
};

export const useAdminChat = (chatId) => {
    return useQuery({
        queryKey: ["adminChat", chatId],
        queryFn: async () => {
            const res = await api.get(`/company/chats/${chatId}`);
            return res.data.data;
        },
        enabled: !!chatId,
        refetchInterval: 3000, // Poll every 3 seconds
    });
};

export const useReplyMessage = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ messageId, content, chatId }) => {
            const res = await api.post(`/company/messages/${messageId}/reply`, {
                content: content.trim(),
                type: "admin",
            });
            return res.data.data;
        },
        onSuccess: (newMessage, { chatId }) => {
            queryClient.setQueryData(["adminChat", chatId], (old) => {
                if (!old) return old;
                return {
                    ...old,
                    messages: [...old.messages, newMessage],
                };
            });

            queryClient.invalidateQueries(["adminChats"]);
            toast.success("Reply sent!");
        },
    });
};

